import { useState } from 'react'
import { useAuth } from '../AuthContext'
import { LanguageSwitcher, useT } from '../i18n'

export function LoginPage() {
  const { login } = useAuth()
  const t = useT()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (submitting) return
    setError(null)
    setSubmitting(true)
    const err = await login(email, password)
    if (err) setError(err)
    setSubmitting(false)
  }

  // Certains navigateurs ne declenchent pas la soumission implicite sur Entree.
  // On la force explicitement, preventDefault evitant toute double soumission.
  const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key !== 'Enter' || e.shiftKey) return
    const form = e.currentTarget
    if (!form.checkValidity()) return
    e.preventDefault()
    void handleSubmit(e)
  }

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
        <div className="login-logo">
          <img src="/logo.png" alt="InTouch" style={{ height: '48px', width: 'auto' }} />
          <h1>{t('login.product')}</h1>
        </div>

        {error && <div className="login-error">{error}</div>}

        <label className="login-label">
          {t('common.email')}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
            placeholder="admin@intouch.sn"
            required
            autoFocus
          />
        </label>

        <label className="login-label">
          {t('common.password')}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            placeholder="••••••••"
            required
          />
        </label>

        <button type="submit" className="login-btn" disabled={submitting}>
          {submitting ? t('login.submitting') : t('login.submit')}
        </button>

        {/* Le choix de langue doit précéder la connexion : l'écran lui-même est
            du texte, et l'utilisateur ne doit pas avoir à entrer pour le lire. */}
        <div className="login-lang">
          <LanguageSwitcher />
        </div>
      </form>
    </div>
  )
}
